import "./QuantityComp.css";
import { defineComponent as z, ref as N, computed as q, openBlock as Q, createBlock as R, withCtx as _, createVNode as v, createElementVNode as T, normalizeClass as H, normalizeStyle as P, unref as U, toDisplayString as X } from "vue";
import { W as G } from "./WrapperComp.f674f2c9.js";
import { ButtonComp as E } from "./ButtonComp.js";
import { IconComp as $ } from "./IconComp.js";
import { g as j, c as J } from "./isObjectLike.2a90a4b2.js";
import { i as D } from "./isObject.43a95bba.js";
import { i as K, u as Y } from "./uniqueId.f48d78c2.js";
import { OverflowComp as Z } from "./OverflowComp.js";
import { _ as w } from "./_plugin-vue_export-helper.dad06003.js";
function ee(e, t, n) {
  return e === e && (n !== void 0 && (e = e <= n ? e : n), t !== void 0 && (e = e >= t ? e : t)), e;
}
var te = ee, ne = /\s/;
function ie(e) {
  for (var t = e.length; t-- && ne.test(e.charAt(t)); )
    ;
  return t;
}
var ae = ie, oe = ae, le = /^\s+/;
function de(e) {
  return e && e.slice(0, oe(e) + 1).replace(le, "");
}
var re = de, se = re, A = D, ce = K, V = 0 / 0, ue = /^[-+]0x[0-9a-f]+$/i, fe = /^0b[01]+$/i, me = /^0o[0-7]+$/i, be = parseInt;
function ve(e) {
  if (typeof e == "number")
    return e;
  if (ce(e))
    return V;
  if (A(e)) {
    var t = typeof e.valueOf == "function" ? e.valueOf() : e;
    e = A(t) ? t + "" : t;
  }
  if (typeof e != "string")
    return e === 0 ? e : +e;
  e = se(e);
  var n = fe.test(e);
  return n || me.test(e) ? be(e.slice(2), n ? 2 : 8) : ue.test(e) ? V : +e;
}
var F = ve, pe = te, B = F;
function _e(e, t, n) {
  return n === void 0 && (n = t, t = void 0), n !== void 0 && (n = B(n), n = n === n ? n : 0), t !== void 0 && (t = B(t), t = t === t ? t : 0), pe(B(e), t, n);
}
var ye = _e;
const xe = /* @__PURE__ */ j(ye);
var ge = J, Ce = function() {
  return ge.Date.now();
}, Te = Ce, he = D, M = Te, W = F, Ie = "Expected a function", ke = Math.max, Se = Math.min;
function Ne(e, t, n) {
  var r, d, a, c, l, s, f = 0, y = !1, m = !1, x = !0;
  if (typeof e != "function")
    throw new TypeError(Ie);
  t = W(t) || 0, he(n) && (y = !!n.leading, m = "maxWait" in n, a = m ? ke(W(n.maxWait) || 0, t) : a, x = "trailing" in n ? !!n.trailing : x);
  function g(i) {
    var u = r, C = d;
    return r = d = void 0, f = i, c = e.apply(C, u), c;
  }
  function I(i) {
    return f = i, l = setTimeout(o, t), y ? g(i) : c;
  }
  function k(i) {
    var u = i - s, C = i - f, O = t - u;
    return m ? Se(O, a - C) : O;
  }
  function p(i) {
    var u = i - s, C = i - f;
    return s === void 0 || u >= t || u < 0 || m && C >= a;
  }
  function o() {
    var i = M();
    if (p(i))
      return b(i);
    l = setTimeout(o, k(i));
  }
  function b(i) {
    return l = void 0, x && r ? g(i) : (r = d = void 0, c);
  }
  function h() {
    l !== void 0 && clearTimeout(l), f = 0, r = s = d = l = void 0;
  }
  function L() {
    return l === void 0 ? c : b(M());
  }
  function S() {
    var i = M(), u = p(i);
    if (r = arguments, d = this, s = i, u) {
      if (l === void 0)
        return I(s);
      if (m)
        return clearTimeout(l), l = setTimeout(o, t), g(s);
    }
    return l === void 0 && (l = setTimeout(o, t)), c;
  }
  return S.cancel = h, S.flush = L, S;
}
var Ee = Ne;
const $e = /* @__PURE__ */ j(Ee), Be = ["value", "tSel", "disabled"], Me = { class: "quantity__enumerators" }, Oe = { class: "quantity__content" }, qe = { class: "quantity__contentTooltip" }, Ae = /* @__PURE__ */ z({
  __name: "QuantityComp",
  props: {
    id: {
      type: String,
      default: () => Y("quantityComp")
    },
    modelValue: {
      type: Number,
      default: 1
    },
    min: {
      type: Number,
      default: 1
    },
    max: {
      type: Number,
      default: 1e4
    },
    label: String,
    labelAbove: Boolean,
    width: String,
    useDebounce: Boolean,
    debounceMilliseconds: {
      type: Number,
      default: 300
    },
    tSel: String,
    disabled: Boolean,
    tooltipMinText: {
      type: String,
      default: ""
    },
    tooltipMaxText: {
      type: String,
      default: ""
    }
  },
  emits: ["update:modelValue"],
  setup(e, { emit: t }) {
    const n = N(), r = N(""), d = N(!1), a = e, c = t, l = q(() => ({ "quantity--disabled": a.disabled })), s = q(() => ({ width: a.width })), f = () => n.value.focus(), y = (o) => {
      const b = parseInt(o.target.value);
      p(b);
    }, m = $e(y, a.debounceMilliseconds), x = () => {
      d.value = !1;
    }, g = (o) => {
      switch (!0) {
        case o < a.min: {
          r.value = a.tooltipMinText, d.value = !0;
          break;
        }
        case o > a.max: {
          r.value = a.tooltipMaxText, d.value = !0;
          break;
        }
        default: {
          d.value = !1;
          break;
        }
      }
    }, I = () => p(a.modelValue + 1), k = () => p(a.modelValue - 1), p = (o) => {
      isNaN(o) && (o = 1), g(o), o = xe(o ?? 1, a.min, a.max), n.value.value = o, c("update:modelValue", o);
    };
    return (o, b) => (Q(), R(Z, {
      show: d.value,
      gray: "",
      arrow: "",
      placement: "bottom-start",
      tooltip: "",
      disabled: !d.value,
      zIndex: "10"
    }, {
      button: _(() => [
        v(G, {
          id: e.id,
          label: e.label,
          labelAbove: e.labelAbove,
          disabled: e.disabled,
          isFocused: ""
        }, {
          default: _(() => [
            T("div", {
              class: H(["quantity", l.value]),
              onClick: f,
              style: P(s.value)
            }, [
              T("input", {
                class: "quantity__input",
                ref_key: "input",
                ref: n,
                type: "number",
                value: a.modelValue,
                onInput: b[0] || (b[0] = (h) => e.useDebounce ? U(m)(h) : y(h)),
                tSel: a.tSel,
                disabled: e.disabled
              }, null, 40, Be),
              T("div", Me, [
                v(E, {
                  onClick: I,
                  blank: "",
                  disabled: e.disabled
                }, {
                  default: _(() => [
                    v($, {
                      class: "icon",
                      icon: "add_small"
                    })
                  ]),
                  _: 1
                }, 8, ["disabled"]),
                v(E, {
                  onClick: k,
                  blank: "",
                  disabled: e.disabled
                }, {
                  default: _(() => [
                    v($, {
                      class: "icon",
                      icon: "remove_small"
                    })
                  ]),
                  _: 1
                }, 8, ["disabled"])
              ])
            ], 6)
          ]),
          _: 1
        }, 8, ["id", "label", "labelAbove", "disabled"])
      ]),
      content: _(() => [
        T("div", Oe, [
          T("span", qe, X(r.value), 1),
          v(E, {
            onClick: x,
            "aria-label": "Close tooltip",
            blank: ""
          }, {
            default: _(() => [
              v($, {
                color: "white",
                class: "quantity__contentButton",
                icon: "close_small",
                label: "Close"
              })
            ]),
            _: 1
          })
        ])
      ]),
      _: 1
    }, 8, ["show", "disabled"]));
  }
});
const Pe = /* @__PURE__ */ w(Ae, [["__scopeId", "data-v-d7f48c79"]]);
export {
  Pe as QuantityComp
};
//# sourceMappingURL=QuantityComp.js.map
